import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { CommerceLandingPort } from '../../../domain/commerce-registry/ports/commerce-landing.port';
import type { CommerceLanding } from '../../../domain/commerce-registry/models/commerce-landing.model';

/**
 * Deduplicates RTDB/API work when the route guard and a page both call {@link execute} with the
 * same slug and programa (sequential subscribers still share one underlying HTTP chain).
 */
@Injectable({ providedIn: 'root' })
export class LoadCommerceLandingUseCase {
  private readonly gateway = inject(CommerceLandingPort);
  private cacheKey: string | null = null;
  private cached$: Observable<CommerceLanding | null> | null = null;

  execute(comercioSlug: string, programaSlug?: string | null): Observable<CommerceLanding | null> {
    const key = `${comercioSlug.trim()}|${programaCacheKey(programaSlug)}`;

    if (this.cacheKey === key && this.cached$ != null) {
      return this.cached$;
    }

    this.cacheKey = key;
    this.cached$ = this.gateway.loadBySlug(comercioSlug, programaSlug).pipe(
      shareReplay({ bufferSize: 1, refCount: false }),
    );
    return this.cached$;
  }
}

/** Stable cache segment; keeps `undefined` (omitted) distinct from explicit `null`. */
function programaCacheKey(programaSlug?: string | null): string {
  if (programaSlug === undefined) {
    return '';
  }
  if (programaSlug === null) {
    return '::null::';
  }
  return programaSlug.trim();
}
